import { createFileRoute, redirect } from "@tanstack/react-router";

/** Ruta legada: marcas vive en /app/marcas (mismo nivel que productos/categorías). */
export const Route = createFileRoute("/app/catalogacion/marcas")({
  beforeLoad: () => {
    throw redirect({ to: "/app/marcas" });
  },
});
